<div class="p-grid" style="margin: 15px;">

    <p-panel class="p-col-12" header="INFOS PTL">
        
        <table>
            <tr>
                <td>Num PTL</td>
                <td>:</td>
                <td>{{infoPtl.loginPtl}}</td>
            </tr>
            <tr>
                <td>ID Bon Plan</td>
                <td>:</td>
                <td>{{infoPtl.idBonPlan}}</td>
            </tr>
            <tr>
                <td>Type PTL</td>
                <td>:</td>
                <td>{{infoPtl.typePtl}}</td>
            </tr>
            <tr>
                <td>Enseigne PTL</td>
                <td>:</td>
                <td>{{infoPtl.enseigne}}</td>
            </tr>
            <tr>
                <td>Date arrivée</td>
                <td>:</td>
                <td>{{infoPtl.dateArrivee}}</td>
            </tr>
            <tr>
                <td>Etat</td>
                <td>:</td>
                <td>{{infoPtl.etat}}</td>
            </tr>
            <tr>
                <td>Complexité</td>
                <td>:</td>
                <td>{{infoPtl.complexite}}</td>
            </tr>
        </table>
    </p-panel>


    <p-panel class="p-col-12" header="LISTE DES CONTENUS">
        
        <p-table #dt [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="contenuCols" [value]="listeContenus" >
            <ng-template pTemplate="caption">
                
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of contenuCols" [pSortableColumn]="col.field" [class]="(col.field === 'numPointAccueil') ? 'set-min' : ''">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-contenus let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{contenus[col.field]}}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8" style="text-align:center; height: 50px;" >Aucun contenu.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>

</div>